export const UploadIcon = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.30005 16.558C9.14937 16.5664 8.99927 16.5707 8.85 16.5707C4.87355 16.5707 3 13.5328 3 9.78534C3 6.0379 6.22355 3 10.2 3C12.493 3 14.5357 4.01016 15.8542 5.58403C18.7531 5.91177 21 8.23738 21 11.0576C21 14.1024 18.3809 16.5707 15.15 16.5707C15.0032 16.5707 14.8576 16.5656 14.7134 16.5556L14.7 16.5707H9.30005V16.558Z'
      fillOpacity='var(--nav-icon-fill-opacity, 0)'
      fill='currentColor'
    />
    <path
      d='M4.8 15.0251C3.67975 13.7492 3 12.0733 3 10.2377C3 6.24043 6.22355 3 10.2 3C12.4737 3 14.2805 4.05949 15.6 5.71414'
      stroke='currentColor'
      strokeWidth='1.25'
      strokeLinecap='round'
    />
    <path
      d='M17.1907 15.6729C16.8655 15.7884 16.6955 16.1458 16.811 16.471C16.9266 16.7963 17.284 16.9663 17.6092 16.8507L17.1907 15.6729ZM15.6 6.33913C18.2341 6.33913 20.375 8.48655 20.375 11.1424H21.625C21.625 7.80236 18.9306 5.08913 15.6 5.08913V6.33913ZM20.375 11.1424C20.375 13.2349 19.0451 15.014 17.1907 15.6729L17.6092 16.8507C19.9496 16.0192 21.625 13.777 21.625 11.1424H20.375Z'
      fill='currentColor'
    />
    <path
      d='M8.3999 16.5718L10.7223 13.8959C10.9216 13.6661 11.2782 13.6661 11.4775 13.8959L13.7999 16.5718'
      stroke='currentColor'
      strokeWidth='1.25'
      strokeLinecap='round'
    />
    <path
      d='M11.1 13.8496V20.4607'
      stroke='currentColor'
      strokeWidth='1.25'
      strokeLinecap='round'
    />
  </svg>
);
